/** @jsx jsx */
import React, { useState } from "react";
import { jsx, css } from "@emotion/core";

import { ColoredH2 } from "../../components/ColoredHeader";
import CheckList from "../../components/CheckList";
import PrimaryCTAButton from "../../components/PrimaryCTA";
import { CenteredHero } from "../../components/HeroImage";
import { colors } from "../../theme";

import hero from "./assets/girl-writing.png";

import PageContainer from "../components/PageContainer";
import { Redirect } from "react-router";

import { post } from "../api";
import { resourceUrls } from "../../config";
import { handlePost } from "../api/handler";

const submitAcceptance = async (
    setLoggedIn,
    setError,
    setFormSubmissionComplete
) => {
    await handlePost({
        postApiCall: () =>
            post({
                url: resourceUrls.intro.submit,
            }),
        setIsLoggedIn: setLoggedIn,
        setError: setError,
        setIsSubmissionComplete: setFormSubmissionComplete,
    });
};

const Intro = () => {
    const [isLoggedIn, setIsLoggedIn] = useState(true);
    const [error, setError] = useState(null);
    const [formSubmissionComplete, setFormSubmissionComplete] = useState(false);

    if (formSubmissionComplete) {
        return (
            <Redirect
                push
                to={{
                    pathname: "/secure/apply",
                }}
            />
        );
    }

    return (
        <PageContainer isLoggedIn={isLoggedIn} error={error}>
            <CenteredHero src={hero} alt="Happy students" />
            <ColoredH2 color={colors.accent5}>
                Welcome to the MyTutor Application Process{" "}
                <span role="img" aria-label="waving hand">
                    &#x1F44B;
                </span>
            </ColoredH2>
            <p>
                This shouldn’t take more than 10 minutes to complete. Ready to
                get going?
            </p>
            <CheckList
                doneItems={["Sign up"]}
                currentItem="Submit application"
                toDoItems={["Complete interview", "Finish onboarding"]}
            />
            <div
                css={css`
                    margin-left: 40px;
                    margin-bottom: 16px;
                `}
            >
                <p>
                    You'll need an Enhanced DBS check for this step. If you
                    don't have one, you can apply for it (costs £41). More info{" "}
                    <a
                        href="https://intercom.help/mytutor_help/en/articles/6332022-i-m-applying-to-be-a-tutor-what-is-a-valid-dbs-check-and-what-do-i-need-to-do"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {" "}
                        here.
                    </a>
                </p>
            </div>
            <PrimaryCTAButton
                type="button"
                data-testid="next-button"
                onClick={() =>
                    submitAcceptance(
                        setIsLoggedIn,
                        setError,
                        setFormSubmissionComplete
                    )
                }
            >
                Next →
            </PrimaryCTAButton>
        </PageContainer>
    );
};

export default Intro;
